<template>
  <div class="shop-table__line shop-table__line__packages">
    <div class="variations_button">
      <div class="single-product__cart-choices">
        <div class="single-product__quantity">
          <div class="quantity">
            <div class="quantity__amount">
              <button v-on:click="changeInputQuantity('decrease', $event)" class="js-quantity-down">-</button>
              <input
                :min="minQuantity"
                :max="maxQuantity"
                :step="buyingStep"
                name="quantity"
                type="text"
                :value="inputValue"
                ref="add_to_cart_input"
                @invalid="customValidation"
                @change="checkBuyingStep"
              />
              <span v-if="measurementUnit && showMeasurementUnit">{{ measurementUnit }}</span>
              <button  v-on:click="changeInputQuantity('increase', $event)" class="js-quantity-up">+</button>
            </div>

            <div v-if="packages.length" class="quantity__packages">
              <select name="package_type" ref="package_select">
                <option
                  v-for="productPackage in packages"
                  :key="productPackage.package_type_id"
                  :value="productPackage.package_type_id"
                  :selected="productPackage.package_type_id === currentPackage"
                >
                  {{ productPackage.package_type_name }}
                  <template v-if="productPackage.package_type_id != 'PT'">
                    ({{ productPackage.qnty_in_package }}{{ measurementUnit }})
                  </template>
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    
      
      <button type="submit" name="submit" :style="addToCartColor != '' ? {'background-color': addToCartColor} : ''" class="button">{{ translations.addToCart }}</button>

    </div>
    
    <div class="loader" v-if="isLoading">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
form {
  position: relative;

  .add-to-cart {
    display: flex;
    border: 0.1rem solid;
    border-radius: 0.5rem;
    margin: 0.3rem 0;
    overflow: hidden;
    align-items: stretch;

    input {
      padding: 0.3rem;
      text-align: center;
      overflow: hidden;
      width: 6rem;
      background-color: $color-white;
    }

    button {
      font-size: 1.6rem;
      letter-spacing: 0.16rem;
      line-height: 1.4rem;
      padding: 0.3rem;
      text-transform: uppercase;
      font-weight: bold;
      width: 6rem;
    }
  }

  .loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(54, 54, 54, 0.315);
  }
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 35%;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
}
</style>
<script>
import Decimal from 'decimal.js';
import Choices from 'choices.js';


export default {
  name: "WellsAddToCart",
  props: {
    id: Number,
    minQuantity: Number,
    maxQuantity: Number,
    isLoading: Boolean,
    measurementUnit: String,
    productTitle: String,
    buyingStep: Number,
    packages: Array,
    currentPackage: String,
    addToCartColor: String
  },
  mounted() {
    if (this.$refs.package_select) {
      new Choices(this.$refs.package_select, {
        searchEnabled: false,
        searchChoices: false,
        shouldSort: false
      });
      this.$refs.package_select.addEventListener('change', e => this.packageSelected(e));
    }
  },

  methods: {
    getMinQuantity() {
      if (ws_vue_store.enable_buying_step !== '1') {
        return this.minQuantity;
      }
      return this.buyingStep;
    },
    
    // Convert a valid number to string with a different comma separator
    inputToString(value) {
      return value.toString().replace('.', this.$store.state.numberSeparator);
    },

    // Convert a string number with a custom separator to a valid number
    inputToNumber(value) {
      return Number(value.replace(this.$store.state.numberSeparator, '.'));
    },

    customValidation() {
      this.checkBuyingStep();
      let el = this.$refs.add_to_cart_input;
      let max = el.getAttribute('max');
      let value = this.inputToNumber(this.inputValue);

      if (parseInt(value) > parseInt(max)) {
        el.setCustomValidity(ws_vue_store.translations.add_to_cart_invalid_message);
      } else {
        el.setCustomValidity('');
      }
    },

    checkBuyingStep() {
      this.lastValidation = Date.now();
      let stopAddToCart = false;
      let quantity = this.inputToNumber(this.$refs.add_to_cart_input.value);
      if (isNaN(quantity)) quantity = this.minQuantity;

      if (this.isOpenNotEnoughForm()) {
        stopAddToCart = true;
      } else if (quantity > this.maxQuantity) {
        this.showNotEnoughForm();
        stopAddToCart = true;
      }

      this.setInputValue(quantity, this.minQuantity, this.maxQuantity);
      this.$emit('quantityChanged', quantity);
      return stopAddToCart;
    },

    isOpenNotEnoughForm() {
      const modalForm = document.getElementById('ws-not-enough-form');
      return modalForm && modalForm.classList.contains('active');
    },

    packageSelected(event) {
      this.$store.commit('addSelectedPackages', {
        id: this.id,
        package: event.currentTarget.value
      });
      this.$emit('packageChanged');

      let selectedPackageData = this.packages.find(e => e.package_type_id == event.currentTarget.value);
      if (selectedPackageData) {
        this.inputValue = this.inputToString(selectedPackageData.qnty_in_package);
        this.$emit('quantityChanged', selectedPackageData.qnty_in_package.toString());
      }
    },

    showNotEnoughForm() {
      const modalForm = document.getElementById('ws-not-enough-form');
      const pageShadow = document.getElementById('js-page-shadow');
      const pageBody = document.querySelector('body');

      if (!modalForm || modalForm.classList.contains('active')) return;

      let maxQty = this.maxQuantity;
      let subjectContent = this.productTitle;
      let unit = this.measurementUnit;

      modalForm.querySelector('.product-name').textContent = subjectContent;
      modalForm.querySelector('input[name="your-subject"]').value = subjectContent;
      modalForm.querySelector('.js_not_enough_qty').innerText = maxQty;
      modalForm.querySelector('.js_not_enough_unit').innerText = unit;

      modalForm.classList.add('active');
      pageShadow.style.display = 'block';
      pageBody.style.overflowY = 'hidden';
    },

    changeInputQuantity(trend, event) {
      event.preventDefault();

      // Pressing "enter" key on quantity input also triggers "-" button
      // This checks that "enter" key wasn't used right now for changing quantity
      if ((Date.now() - this.lastValidation) < 500) {
        return;
      }

      let el = this.$refs.add_to_cart_input;
      let max = new Decimal(el.getAttribute('max'));
      let min = new Decimal(el.getAttribute('min'));
      let step = new Decimal(el.getAttribute('step'));

      let current_quantity = this.inputToNumber(el.value);
      current_quantity = new Decimal(current_quantity);

      let new_value = new Decimal(0);
      if (trend === 'increase' && (current_quantity.plus(step)).lte(max)) {
        new_value = current_quantity.plus(step);
      }
      if (trend === 'decrease' && (current_quantity.minus(step)).gte(min)) {
        new_value = current_quantity.minus(step);
      }

      if (!new_value.equals(new Decimal(0))) {
        this.inputValue = this.inputToString(new_value);
        this.$emit('quantityChanged', new_value.toString());
      }
    },

    setInputValue(quantity, step, maxQuantity) {
      let calculation;

      if (+(quantity % step).toFixed(2) !== 0 || quantity > maxQuantity) {
        if (Math.ceil(quantity / step) * step > maxQuantity) {
          let qty = Math.ceil(maxQuantity / step);
          calculation = qty * step <= maxQuantity ? qty * step : qty * step - step;
        } else {
          calculation = Math.ceil(quantity / step) * step;
        }

        // Round the value
        if (Number.isSafeInteger(step)) {
          calculation = Math.round(calculation);
        } else {
          calculation = +(calculation).toFixed(2);
        }
      } else {
        calculation = quantity;
      }

      this.inputValue = this.inputToString(Math.abs(calculation));
      this.$refs.add_to_cart_input.value = this.inputValue;
    }
  },
  data() {
    let minQty = ( ! this.currentPackage || this.currentPackage === 'PT') ? this.minQuantity : 1;

    return {
      lastValidation: 0,
      inputValue: this.inputToString(this.minQuantity),
      showMeasurementUnit: ws_vue_store.show_measurement_unit === '1',
      translations: {
        addToCart: ws_vue_store.translations.add_to_cart,
        invalidMessage: ws_vue_store.translations.add_to_cart_invalid_message
      }
    };
  }
};

</script>
